import React, { memo } from 'react'

import { func, shape } from 'prop-types'

import { imageShape } from 'Pods/LazyLoaded/ImageGalleryPanel/imageShape'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import Creator from './Components/Creator/Creator'
import GenerationSettings from './Components/GenerationSettings/GenerationSettings'
import Prompt from './Components/Prompt/Prompt'
import SimilarImages from './Components/SimilarImages/SimilarImages'

// Similar images stay empty until the community payload carries the asset id the
// similar-images endpoint is keyed on.
function Details({ image, onSelect = NOOP }) {
  return (
    <div className="image-gallery-modal__details">
      <div className="image-gallery-modal__summary">
        <Creator user={image.user} createdAt={image.createdAt} />
        <Prompt text={image.prompt} />
        <GenerationSettings settings={image.settings} />
      </div>
      <SimilarImages images={EMPTY_ARRAY} onSelect={onSelect} />
    </div>
  )
}

Details.propTypes = {
  image: shape(imageShape).isRequired,
  onSelect: func,
}

export default memo(Details)
